/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Mini_GInputs */

const en_tut_mini_g = /** @type {(inputs: Tut_Mini_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have to stare at the map all day. Mini Mode keeps presence and the people list in a small window while you work in another app.`)
};

const id_tut_mini_g = /** @type {(inputs: Tut_Mini_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda tidak harus menatap peta seharian. Mini Mode menyimpan kehadiran dan daftar rekan di jendela kecil sementara Anda bekerja di aplikasi lain.`)
};

/**
* | output |
* | --- |
* | "You do not have to stare at the map all day. Mini Mode keeps presence and the people list in a small window while you work in another app." |
*
* @param {Tut_Mini_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_mini_g = /** @type {((inputs?: Tut_Mini_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Mini_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_mini_g(inputs)
	return en_tut_mini_g(inputs)
});